<nav class="bottom-nav">
  @for (item of items(); track item.path) {
    <a
      class="bottom-nav__item"
      [routerLink]="item.path"
      routerLinkActive="bottom-nav__item--active"
      #rla="routerLinkActive"
    >
      <ion-icon [name]="rla.isActive ? item.activeIcon : item.icon" class="bottom-nav__icon"></ion-icon>
      <span class="bottom-nav__label">{{ item.label }}</span>
    </a>
  }
</nav>
